(() => {
  const money = (cents, format = '${{amount}}') => {
    const value = (Number(cents || 0) / 100).toFixed(2);
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents, format);
    return `$${value.replace(/\.00$/, '')}`;
  };

  const trapDialogBackdrop = (dialog) => {
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  };

  const initHeader = (root = document) => {
    const menu = root.querySelector('[data-mobile-menu]') || document.querySelector('[data-mobile-menu]');
    const open = root.querySelector('[data-menu-open]') || document.querySelector('[data-menu-open]');
    if (!menu || !open || open.dataset.initialized) return;
    open.dataset.initialized = 'true';
    const close = menu.querySelector('[data-menu-close]');
    const setState = (active) => open.setAttribute('aria-expanded', String(active));
    open.addEventListener('click', () => { menu.showModal(); setState(true); });
    close?.addEventListener('click', () => menu.close());
    menu.addEventListener('close', () => setState(false));
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => menu.close()));
    trapDialogBackdrop(menu);
  };

  const cartDrawer = () => document.querySelector('#CartDrawer');
  const updateCartCounts = (count) => document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = count; });

  const renderCart = async (openAfter = false) => {
    const drawer = cartDrawer();
    if (!drawer) return;
    const content = drawer.querySelector('[data-cart-drawer-content]');
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await response.json();
      updateCartCounts(cart.item_count);
      if (!content) return;
      if (!cart.item_count) {
        content.innerHTML = '<div class="cart-empty"><span>GOOD GEAR. NEXT STOP.</span><h3>Your bag is taking a breather.</h3><p>Find something with a little Carroll\'s character.</p><a class="shop-primary" href="/collections/all">Explore the merchandise</a></div>';
      } else {
        const items = cart.items.map((item, index) => `
          <article class="cart-line">
            ${item.image ? `<img src="${item.image}" width="100" height="126" alt="">` : ''}
            <div><a href="${item.url}">${item.product_title}</a><p>${item.variant_title || ''}</p><strong>${money(item.final_line_price)}</strong>
            <div class="cart-line-bottom"><input class="cart-quantity-input" type="number" min="0" value="${item.quantity}" aria-label="Quantity for ${item.product_title}" data-cart-line="${index + 1}"><button class="shop-text-button" type="button" data-cart-remove="${index + 1}">Remove</button></div></div>
          </article>`).join('');
        content.innerHTML = `<div class="cart-lines">${items}</div><div class="cart-summary"><div><span>Subtotal</span><strong>${money(cart.total_price)}</strong></div><p>Shipping and taxes are calculated at checkout.</p><a class="shop-primary" href="/checkout">Continue to checkout</a><a class="continue-shopping" href="/cart">View and edit bag</a></div>`;
        content.querySelectorAll('[data-cart-remove]').forEach((button) => button.addEventListener('click', async () => {
          await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: Number(button.dataset.cartRemove), quantity: 0 }) });
          renderCart(true);
        }));
        content.querySelectorAll('[data-cart-line]').forEach((input) => input.addEventListener('change', async () => {
          await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: Number(input.dataset.cartLine), quantity: Math.max(0, Number(input.value)) }) });
          renderCart(true);
        }));
      }
      if (openAfter && !drawer.open) drawer.showModal();
    } catch (error) {
      console.error('Cart update failed', error);
    }
  };

  const initCart = (root = document) => {
    const drawer = cartDrawer();
    document.querySelectorAll('[data-cart-open]').forEach((button) => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      button.addEventListener('click', () => renderCart(true));
    });
    if (drawer && !drawer.dataset.initialized) {
      drawer.dataset.initialized = 'true';
      drawer.querySelector('[data-cart-close]')?.addEventListener('click', () => drawer.close());
      trapDialogBackdrop(drawer);
    }
    root.querySelectorAll('[data-product-form]').forEach((form) => {
      if (form.dataset.ajaxInitialized) return;
      form.dataset.ajaxInitialized = 'true';
      form.addEventListener('submit', async (event) => {
        const submitter = event.submitter;
        if (submitter?.name !== 'add') return;
        event.preventDefault();
        submitter.disabled = true;
        submitter.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
          if (!response.ok) throw new Error(await response.text());
          await renderCart(true);
        } catch (error) {
          console.error('Add to cart failed', error);
          form.querySelector('[data-add-label]').textContent = 'Please try again';
        } finally {
          submitter.disabled = false;
          submitter.removeAttribute('aria-busy');
        }
      });
    });
  };

  const initServiceTabs = (root = document) => {
    root.querySelectorAll('[data-service-tabs]').forEach((section) => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const tabs = [...section.querySelectorAll('[data-service-tab]')];
      const panels = [...section.querySelectorAll('[data-service-panel]')];
      const activate = (id, focus = false) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.serviceTab === id;
          tab.classList.toggle('active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && focus) tab.focus();
        });
        panels.forEach((panel) => { panel.hidden = panel.dataset.servicePanel !== id; });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab.dataset.serviceTab));
        tab.addEventListener('keydown', (event) => {
          const delta = ['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : ['ArrowLeft', 'ArrowUp'].includes(event.key) ? -1 : 0;
          if (!delta && !['Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + delta + tabs.length) % tabs.length;
          activate(tabs[next].dataset.serviceTab, true);
        });
      });
    });
  };

  const initMerchFilters = (root = document) => {
    root.querySelectorAll('[data-merch-filter]').forEach((section) => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const buttons = section.querySelectorAll('[data-filter]');
      const cards = section.querySelectorAll('[data-product-category]');
      buttons.forEach((button) => button.addEventListener('click', () => {
        const filter = button.dataset.filter;
        buttons.forEach((item) => { const active = item === button; item.classList.toggle('active', active); item.setAttribute('aria-pressed', String(active)); });
        cards.forEach((card) => { card.hidden = filter !== 'all' && card.dataset.productCategory !== filter; });
      }));
    });
  };

  const initGallery = (root = document) => {
    root.querySelectorAll('[data-gallery]').forEach((section) => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const track = section.querySelector('[data-gallery-track]');
      const items = [...section.querySelectorAll('[data-gallery-item]')];
      const dialog = section.querySelector('[data-gallery-dialog]');
      const image = dialog?.querySelector('[data-gallery-large]');
      const status = dialog?.querySelector('[data-gallery-status]');
      let selected = 0;
      const show = (index) => {
        selected = (index + items.length) % items.length;
        const cardImage = items[selected].querySelector('img');
        const title = items[selected].querySelector('strong')?.textContent || '';
        image.src = cardImage.currentSrc || cardImage.src;
        image.alt = cardImage.alt;
        status.textContent = `${selected + 1} / ${items.length} · ${title}`;
      };
      items.forEach((item, index) => item.addEventListener('click', () => { show(index); dialog.showModal(); }));
      const moveTrack = (direction) => track?.scrollBy({ left: direction * ((items[0]?.offsetWidth || 300) + 24), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      section.querySelector('[data-gallery-prev]')?.addEventListener('click', () => moveTrack(-1));
      section.querySelector('[data-gallery-next]')?.addEventListener('click', () => moveTrack(1));
      section.querySelector('[data-gallery-modal-prev]')?.addEventListener('click', () => show(selected - 1));
      section.querySelector('[data-gallery-modal-next]')?.addEventListener('click', () => show(selected + 1));
      section.querySelector('[data-gallery-close]')?.addEventListener('click', () => dialog.close());
      trapDialogBackdrop(dialog);
    });
  };

  const initProduct = (root = document) => {
    root.querySelectorAll('[data-product-section]').forEach((section) => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const form = section.querySelector('[data-product-form]');
      const variantsNode = section.querySelector('[data-product-variants]');
      const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
      const variantInput = section.querySelector('[data-variant-id]');
      const addButton = section.querySelector('[data-add-to-cart]');
      const addLabel = section.querySelector('[data-add-label]');
      const priceNodes = section.querySelectorAll('[data-product-price], [data-button-price]');
      const sticky = section.querySelector('[data-sticky-cart]');
      const stickyText = section.querySelector('[data-sticky-variant]');
      const stickyButton = section.querySelector('[data-sticky-submit]');
      const updateVariant = () => {
        const selections = [...section.querySelectorAll('[data-option-position]')].map((select) => select.value);
        const variant = variants.find((item) => item.options.every((value, index) => value === selections[index])) || variants[0];
        if (!variant) return;
        variantInput.value = variant.id;
        priceNodes.forEach((node) => { node.textContent = money(variant.price, section.dataset.moneyFormat); });
        addButton.disabled = !variant.available;
        addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
        if (stickyButton) { stickyButton.disabled = !variant.available; stickyButton.textContent = variant.available ? 'Add to cart' : 'Sold out'; }
        if (stickyText) stickyText.textContent = `${variant.title} · ${money(variant.price, section.dataset.moneyFormat)}`;
        const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
      };
      section.querySelectorAll('[data-option-position]').forEach((select) => select.addEventListener('change', updateVariant));
      stickyButton?.addEventListener('click', () => addButton?.click());
      const purchase = section.querySelector('[data-purchase-area]');
      if (sticky && purchase) new IntersectionObserver(([entry]) => { sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; }).observe(purchase);

      const mainImage = section.querySelector('[data-product-main-image]');
      const zoomImage = section.querySelector('[data-product-zoom-image]');
      const zoom = section.querySelector('[data-product-zoom]');
      section.querySelectorAll('[data-product-thumbnail]').forEach((thumb, index) => thumb.addEventListener('click', () => {
        if (!mainImage || !thumb.dataset.imageSrc) return;
        [mainImage, zoomImage].filter(Boolean).forEach((image) => {
          // Clear the previous image's responsive sources before selecting another view.
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = thumb.dataset.imageSrc;
          image.alt = thumb.dataset.imageAlt || '';
        });
        section.querySelectorAll('[data-product-thumbnail]').forEach((item) => { item.classList.toggle('selected', item === thumb); item.setAttribute('aria-pressed', String(item === thumb)); });
        const count = section.querySelector('[data-gallery-count]'); if (count) count.textContent = `${String(index + 1).padStart(2, '0')} / ${String(section.querySelectorAll('[data-product-thumbnail]').length).padStart(2, '0')}`;
      }));
      section.querySelector('[data-product-zoom-open]')?.addEventListener('click', () => zoom?.showModal());
      section.querySelector('[data-product-zoom-close]')?.addEventListener('click', () => zoom?.close());
      trapDialogBackdrop(zoom);
      initCart(section);
    });
  };

  const initRecommendations = (root = document) => {
    root.querySelectorAll('product-recommendations[data-url]').forEach((element) => {
      if (element.dataset.initialized) return;
      element.dataset.initialized = 'true';
      new IntersectionObserver((entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(element);
        fetch(element.dataset.url).then((response) => response.text()).then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html').querySelector('product-recommendations');
          if (html?.innerHTML.trim()) element.innerHTML = html.innerHTML;
        }).catch((error) => console.error('Recommendations failed', error));
      }, { rootMargin: '0px 0px 300px 0px' }).observe(element);
    });
  };

  const init = (root = document) => {
    initHeader(root); initCart(root); initServiceTabs(root); initMerchFilters(root); initGallery(root); initProduct(root); initRecommendations(root);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const block = event.target;
    const service = block.closest('[data-service-tabs]');
    const tab = service?.querySelector(`[data-service-tab="${event.detail.blockId}"]`);
    tab?.click();
    block.scrollIntoView({ block: 'center', behavior: 'smooth' });
  });
})();
